import React from 'react';
import fonts from '../../../../assets/creator/availableFonts';

import './StyleMenuFonts.css';



const fontStyles = [
    {
        displayName: "Light",
        fontWeight: 300
    },
    {
        displayName: "Regular",
        fontWeight: 400
    },
    {
        displayName: "Medium",
        fontWeight: 500
    },
    {
        displayName: "Bold",
        fontWeight: 700,
        lastFontStyle: true
    }
];

const StyleMenuFonts = ({ onFontSelect, currentFont }) => (
    <React.Fragment>
        <FontSelector onFontSelect={onFontSelect} currentFont={currentFont}/>
    </React.Fragment>
)

export default StyleMenuFonts;

const FontSelector = ({onFontSelect, currentFont}) => (
    <div className="font-selector">
        
        <ul className="font-list">
            {MapFontsToOptions(onFontSelect, currentFont)}
        </ul>
    </div>
)

const getClassname = (font, currentFont) => {
    if (font === currentFont) {
        return "font font--selected";
    }
    return "font font--not-selected";
}

const MapFontsToOptions = (onFontSelect, currentFont) => fonts.map((font) => (
    
    <li
    
        key={font}
        className={getClassname(font,currentFont)}
        onClick={() => onFontSelect(font)}
    >
        <p className='font__show' style={{ fontFamily: font }}>Aa</p>
        <div className='font__conatiner'>
            <div className="font__name" style={{ fontFamily: font }}>{font}</div>
            <FontPreview font={font} />
        </div>
        
    </li>
))
const FontPreview = ({ font }) => (
    <div className="font__container">
        {fontStyles.map((fontStyle) => (
            <span
                key={fontStyle.displayName}
                className="font__preview"
                style={{
                    fontFamily: font,
                    fontWeight: fontStyle.fontWeight
                }}
            >
                {fontStyle.displayName}
                {!fontStyle.lastFontStyle && ', '}
            </span>
        ))}
    </div>
);